import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '明星八卦', to: '/category/star' },
  { label: '网红翻车', to: '/category/influencer' },
  { label: '素人投稿', to: '/category/submit' },
  { label: '深度追踪', to: '/category/deep' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur'
          : 'border-transparent bg-background-50'
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between px-4 md:px-8">
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="18爆料网首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
              18
            </span>
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
              爆料网
            </span>
          </Link>
          <span className="hidden items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900 lg:flex">
            <i className="ri-fire-line" aria-hidden="true"></i>
            今日更新 38 条
          </span>
        </div>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <i className="ri-notification-3-line" aria-hidden="true"></i>
            订阅爆料
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
            aria-label={open ? '关闭菜单' : '展开菜单'}
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden"
          aria-label="移动端导航"
        >
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`mb-1 flex items-center justify-between rounded-md px-3 py-2.5 text-sm font-medium ${
                isActive(item.to)
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-800 hover:bg-background-100'
              }`}
            >
              {item.label}
              <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            </Link>
          ))}
          <a
            href="#subscribe"
            className="mt-2 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-notification-3-line" aria-hidden="true"></i>
            订阅爆料
          </a>
        </nav>
      )}
    </header>
  );
}